(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offset-image-collection"] && !Shopify.designMode) return;
  try {
    
function loadScript(url, callback)
{
    // Adding the script tag to the head as suggested before
    var head = document.head;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // Then bind the event to the callback function.
    // There are several events for cross browser compatibility.
    script.onreadystatechange = callback;
    script.onload = callback;

    // Fire the loading
    head.appendChild(script);
}

loadScript('https://unpkg.com/imagesloaded@4/imagesloaded.pkgd.min.js', setupMasonry);
loadScript('https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js', setupMasonry);


function setupMasonry() {
  	if(typeof imagesLoaded === 'function' && typeof Masonry === 'function') {
      imagesLoaded(document.querySelectorAll('.image-collection__image'), function() {
          var containers = document.querySelectorAll('.image-collection__images');
          [].forEach.call(containers, function(elm) {
              new Masonry(elm, {
                itemSelector: '.image-collection__image',
                gutter: 30,
              });
          });
      });
	}
}

  } catch(e) { console.error(e); }
})();
})();
